<template>
	<div
		class="g-block-title-sidebar g-block-title-padding"
		:class="{
			'g-block-title-sidebar--edit': editable,
			'is-active': editable && active,
			'g-block-title-sidebar--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-sidebar__row">
			<div class="g-block-title-sidebar__bar" :style="{ background: themeColor }"></div>
			<div class="g-block-title-sidebar__content">
				<div class="g-block-title-sidebar__part g-block-title-sidebar__part--primary" :style="{ color: themeColor }">
					<RichTextEditable
						v-if="editable"
						class="g-block-title-sidebar__text g-block-title-sidebar__text--primary"
						fit-content
						:model-value="data.primaryText"
						placeholder="中文标题"
						@update:model-value="onPrimaryUpdate"
						@focus="onWrapClick"
					/>
					<div
						v-else
						class="g-block-title-sidebar__text g-block-title-sidebar__text--primary"
						v-html="data.primaryText || ''"
					></div>
				</div>
				<div class="g-block-title-sidebar__part g-block-title-sidebar__part--secondary" :style="{ color: lightColor }">
					<RichTextEditable
						v-if="editable"
						class="g-block-title-sidebar__text g-block-title-sidebar__text--secondary"
						fit-content
						:model-value="data.secondaryText"
						placeholder="中文副标题"
						@update:model-value="onSecondaryUpdate"
						@focus="onWrapClick"
					/>
					<div
						v-else
						class="g-block-title-sidebar__text g-block-title-sidebar__text--secondary"
						v-html="data.secondaryText || ''"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { dualTitleMixin } from '../shared/dualTitleMixin.js';

	export default {
		name: 'GBlockTitleSidebar',
		components: { RichTextEditable },
		mixins: [dualTitleMixin],
	};
</script>

<style scoped lang="less">
	@bar-width: 4px;

	.g-block-title-sidebar {
		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-title-sidebar__row {
		display: flex;
		align-items: stretch;
		gap: 10px;
	}

	.g-block-title-sidebar__bar {
		width: @bar-width;
		flex-shrink: 0;
		border-radius: 2px;
	}

	.g-block-title-sidebar__content {
		display: flex;
		flex-direction: column;
		gap: 6px;
		min-width: 0;
	}

	.g-block-title-sidebar__part {
		min-width: 0;
	}

	.g-block-title-sidebar__text {
		display: inline-flex;
		align-items: baseline;
		line-height: 1.3;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;
		color: inherit;

		&--primary {
			font-size: 24px;
			font-weight: 700;
		}

		&--secondary {
			font-size: 14px;
			font-weight: 400;
		}

		:deep(.g-rich-text-editable) {
			display: inline-flex;
			align-items: baseline;
			width: auto;
			max-width: 100%;
			color: inherit;
		}

		:deep(.g-rich-text-editable__content) {
			line-height: 1.3;
			min-height: unset;
			height: auto;
			padding: 0;
			color: inherit;
		}

		:deep(span),
		:deep(font),
		:deep(p),
		:deep(div) {
			line-height: inherit;
			margin: 0;
			padding: 0;
			vertical-align: baseline;
			color: inherit;
		}
	}

	.g-block-title-sidebar--h5 {
		.g-block-title-sidebar__row {
			gap: 0.2rem;
		}

		.g-block-title-sidebar__bar {
			width: 0.08rem;
		}

		.g-block-title-sidebar__content {
			gap: 0.12rem;
		}

		.g-block-title-sidebar__text--primary {
			font-size: 0.48rem;
		}

		.g-block-title-sidebar__text--secondary {
			font-size: 0.28rem;
		}
	}
</style>
